import { useEffect, useState } from 'react';

const useStickyState = (elementRef: React.RefObject<HTMLElement>) => {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const getTopOffset = () => {
      if (elementRef.current) {
        const computedStyle = window.getComputedStyle(elementRef.current);
        const topValue = computedStyle.top || '0px';
        return parseFloat(topValue); // Convert '1rem' or other units to a number
      }
      return 0;
    };

    const checkSticky = () => {
      if (elementRef.current) {
        const rect = elementRef.current.getBoundingClientRect();
        const topOffset = getTopOffset();
        const isNowSticky = rect.top <= topOffset && rect.bottom > topOffset;
        setIsSticky(isNowSticky);
      }
    };

    window.addEventListener('scroll', checkSticky);
    checkSticky(); // Initial check

    return () => window.removeEventListener('scroll', checkSticky);
  }, [elementRef]);

  return isSticky;
};

export default useStickyState;
